/**
 * Place du Marché — zones de rayons dépliables (Fraîche / Tempérée / non
 * Alimentaire). Voir theme/sections/zone-rayons.liquid.
 *
 * L'état fermé par défaut est déjà posé côté serveur (classe
 * .zone-rayons__contenu--ferme + max-height: 0 en CSS, attributs
 * inert/aria-hidden) pour éviter tout flash de contenu avant le premier
 * paint. Ce script anime les transitions d'ouverture/fermeture au clic et
 * maintient l'accessibilité ensuite.
 *
 * Détail important : une fois l'ouverture terminée, max-height repasse à
 * "none" (via transitionend) plutôt que de rester figé sur un scrollHeight
 * mesuré une fois. Sans ça, une rotation d'écran ou un reflow responsive qui
 * agrandit le contenu serait silencieusement coupé par l'overflow: hidden.
 * On ne fige une hauteur en px qu'au moment de fermer, où elle est toujours
 * remesurée à l'instant du clic.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-zone-rayons]').forEach((zone) => {
    const toggle = zone.querySelector('[data-zone-toggle]');
    const contenu = zone.querySelector('.zone-rayons__contenu');
    if (!toggle || !contenu) return;

    const ouvrir = () => {
      toggle.setAttribute('aria-expanded', 'true');
      zone.toggleAttribute('data-ouverte', true);
      contenu.classList.remove('zone-rayons__contenu--ferme');
      contenu.removeAttribute('inert');
      contenu.removeAttribute('aria-hidden');
      contenu.style.maxHeight = contenu.scrollHeight + 'px';
    };

    const fermer = () => {
      // Fige d'abord la hauteur actuelle en px (au cas où elle valait
      // "none"), puis force un recalcul de style avant de poser la cible à
      // 0 : sans ce recalcul, le navigateur peut fusionner les deux
      // affectations et sauter l'animation.
      contenu.style.maxHeight = contenu.scrollHeight + 'px';
      void contenu.offsetHeight;
      contenu.style.maxHeight = '0px';

      contenu.classList.add('zone-rayons__contenu--ferme');
      contenu.setAttribute('inert', '');
      contenu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      zone.toggleAttribute('data-ouverte', false);
    };

    contenu.addEventListener('transitionend', (event) => {
      if (event.propertyName === 'max-height' && toggle.getAttribute('aria-expanded') === 'true') {
        contenu.style.maxHeight = 'none';
      }
    });

    toggle.addEventListener('click', () => {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        fermer();
      } else {
        ouvrir();
      }
    });
  });
});

/**
 * Compteur panier — theme/sections/pdm-topbar.liquid
 *
 * Rafraîchit [data-alfa-compteur] et [data-alfa-soustotal] à partir de
 * /cart.js (source de vérité côté client, plus fiable que le rendu serveur
 * une fois qu'on est déjà sur la page). Exposée globalement (window) pour
 * être rappelée après un ajout AJAX par les plans suivants (fiche produit,
 * tiroir-panier) sans dépendre d'un rechargement de page.
 */
// Symbole monnaie codé en dur pour coller au format actuel du site ($4.37).
// TODO : remplacer par Shopify.formatMoney(cart.total_price, moneyFormat)
// quand le format de devise du thème sera branché (voir tâche formatage
// monnaie globale, hors périmètre Task 5).
const ALFA_DEVISE_SYMBOLE = '$';

window.alfaMajPanier = async function alfaMajPanier() {
  // try/catch autour de tout le corps : un échec HTTP est géré par `!r.ok`,
  // mais un échec réseau (hors ligne, DNS, WebView capricieuse — voir memory
  // alfa-market-ios-app) fait rejeter la promesse `fetch`/`json` elle-même.
  // Sans ce filet, chaque appel (chargement initial + futurs ajouts AJAX
  // panier des plans suivants) laisserait une rejection non gérée. Échec
  // silencieux (console.debug) : le compteur garde alors sa dernière valeur
  // connue plutôt que de casser la page.
  // Pas de compteur sur la page (ex. templates PageFly hérités) → pas d'appel réseau.
  if (!document.querySelector('[data-alfa-compteur],[data-alfa-soustotal]')) return;
  try {
    // alfaRequete (alfa-rayon.js) : XHR insensible au monkeypatch de fetch
    // par les vieilles apps du thème ; repli fetch si jamais absent.
    const r = window.alfaRequete ? await window.alfaRequete('/cart.js', { accept: 'application/json' }) : await fetch('/cart.js');
    if (!r.ok) return;
    const cart = await r.json();
    document.querySelectorAll('[data-alfa-compteur]').forEach((el) => { el.textContent = cart.item_count; });
    document.querySelectorAll('[data-alfa-soustotal]').forEach((el) => {
      el.textContent = ALFA_DEVISE_SYMBOLE + (cart.total_price / 100).toFixed(2);
    });
  } catch (erreur) {
    console.debug('alfaMajPanier : échec réseau, compteur non rafraîchi', erreur);
  }
};
document.addEventListener('DOMContentLoaded', () => { window.alfaMajPanier(); });
